import { render } from "./AutoCompleteProdutos.vue?vue&type=template&id=76cb7db2&scoped=true"
import script from "./AutoCompleteProdutos.vue?vue&type=script&lang=js"
export * from "./AutoCompleteProdutos.vue?vue&type=script&lang=js"

import "./AutoCompleteProdutos.vue?vue&type=style&index=0&id=76cb7db2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cb7db2"]])

export default __exports__